<template>
  <v-dialog v-model="localValue" scrollable persistent fullscreen hide-overlay>
    <v-card>
      <BulkCreateUsers
        v-if="localValue"
        :type-role="typeRole"
        :team-id="teamId"
        :entity-id="entityId"
        @close="() => (localValue = false)"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import BulkCreateUsers from '@/components/management/users/bulk-create/BulkCreate.vue'

export default {
  name: 'DialogBulkCreateUsers',
  components: { BulkCreateUsers },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    typeRole: {
      type: String,
    },
    teamId: {
      type: String,
    },
    entityId: {
      type: String,
    },
  },
  computed: {
    localValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>

<style></style>
